import { render, staticRenderFns } from "./createRules.vue?vue&type=template&id=332cf117&scoped=true"
import script from "./createRules.vue?vue&type=script&lang=js"
export * from "./createRules.vue?vue&type=script&lang=js"
import style0 from "./createRules.vue?vue&type=style&index=0&id=332cf117&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332cf117",
  null
  
)

export default component.exports